import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * 404 page. Served at the public catch-all route and rendered in place by
 * `<RequireModule>` when the customer's module is disabled — masking the
 * module's existence rather than explaining it. "Return home" links to root.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} sx={{ alignItems: 'flex-start', maxWidth: 480 }}>
      <Typography variant="h4" component="h1">
        {t('notFound.title')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {t('notFound.body')}
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">
        {t('actions.returnHome')}
      </Button>
    </Stack>
  );
}
